import store from '@/store'

const setClass = (element, isDocked) => {
  const isCheckout = store.getters.clientModel.cartType === 1
  if (isDocked && !isCheckout) {
    element.classList.add('wrapper--cart-is-docked')
  } else {
    element.classList.remove('wrapper--cart-is-docked')
  }
}

const dockedClass = {
  bind(el, binding) {
    const unwatch = store.watch((state, getters) => getters['ui/isCartDocked'], isDocked => {
      setClass(el, isDocked)
    })

    const isDocked = store.getters['ui/isCartDocked']
    let unWatchMounted

    if (isDocked !== undefined) {
      unWatchMounted = setClass(el, isDocked)
    }

    el.__isDocked_unwatch__ = unwatch
    el.__isDocked_unwatch_mounted__ = unWatchMounted
  },
  unbind(el) {
    el.__isDocked_unwatch__ && el.__isDocked_unwatch__()
    el.__isDocked_unwatch_mounted__ && el.__isDocked_unwatch_mounted__()
  }
}

export default dockedClass
